/**
 * https://www.unicode.org/reports/tr35/tr35-59/tr35.html#Identifiers
 */

module.exports = {
	i18n: {
		defaultLocale: "en",
		locales: [
			"en",
			"zh-Hans",
			"zh-Hant",
			"vi",
			"id",
			"th",
			"es",
			"pt",
			"ko",
			"ja",
			"jp", //TODO: // 未来要删除 jp
			"zh-HK",
		],
	},
	compatibilityJSON: "v3",
	react: { useSuspense: false }, //this line
};
